module.exports = __webpack_public_path__ + "img/sv68.5f9a5b38.svg";